module.exports = __webpack_public_path__ + "img/img10.d6d26649.png";